export default "__VITE_ASSET__07ac4652__"